module.exports = "\r\n<div class=\"cmui-scrollbox-item float-left pos-r\" v-bind:style=\"{width:itemWidth}\">\r\n\t<slot></slot>\r\n</div>\r\n\r\n";